// Add this to your Shopify theme's JavaScript files (e.g., theme.js)

// 🔧 Replace with your deployed backend URL
const API_SERVER_URL = 'https://shopify-zoho-integration.onrender.com';

// Flag to prevent duplicate tracking
let cartTracked = false;

async function trackCartWithServer() {
  if (cartTracked) return;

  try {
    // Check if user is logged in
    const customer = window.Shopify?.customer || null;
    const ZOHOproducts = window.Shopify?.ZOHOproducts || null;
    

    if (!customer) {
      console.log('👤 User not logged in — skipping abandoned cart tracking.');
      return;
    }

    console.log(`✅ Logged-in customer: ${customer.email}`);

  

    // Fetch current cart
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error("Failed to load Shopify cart");
    const cart = await response.json();

    // Attach customer info to cart
    cart.customer = {
      id: customer.id,
      email: customer.email,
      first_name: customer.first_name,
      last_name: customer.last_name,
      phone: customer.default_address.phone,
      address1: customer.default_address.address1,
      city: customer.default_address.city,
      country: customer.default_address.country,
      province: customer.default_address.province,
      zip: customer.default_address.zip,
    };
    
    cart.ZOHOproducts = ZOHOproducts;
    console.log(cart);

    // Proceed only if cart has items
    if (cart && cart.items && cart.items.length > 0) {
      console.log('🛒 Cart detected, sending to server...');
      cartTracked = true;

      // Send cart with customer details
      await fetch(`${API_SERVER_URL}/api/track-cart`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cart })
      });

      // Detect checkout
      const checkoutForm = document.querySelector('form[action*="/checkout"]');
      if (checkoutForm) {
        checkoutForm.addEventListener('submit', async () => {
          console.log('✅ Checkout started, notifying server...');
          await fetch(`${API_SERVER_URL}/api/checkout-started`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ cartToken: cart.token })
          });
        });
      }
    }
  } catch (error) {
    console.error("❌ Failed to track cart:", error);
  }
}

// Run when page is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', trackCartWithServer);
} else {
  trackCartWithServer();
}
